export default __webpack_public_path__ + "static/media/766.3413a43a.gif";